import React from "react";
import { Button } from "./ui/button";
import { Phone, Mail } from "lucide-react";

const CTASection = () => {
  return (
    <section
      id="cta"
      className="relative py-32 bg-cover bg-center"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1593786267440-550458cc882a?auto=format&fit=crop&w=1920')"
      }}
    >
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <p className="text-lg md:text-xl font-medium mb-4">Turning visions into reality, one construction at a time</p>
        <h2 className="text-4xl md:text-6xl font-bold mb-8">
          Get a <span className="text-blue-400">FREE ESTIMATE</span>
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12">
          <a href="tel:+13058341149">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-md flex items-center gap-2 transition-all hover:scale-105">
              <Phone size={24} />
              Call Us
            </Button>
          </a>
          <a href="mailto:Hidalgodagneris@gmail.com">
            <Button className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-6 text-lg rounded-md flex items-center gap-2 transition-all hover:scale-105">
              <Mail size={24} />
              Email Us
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;